import api from '@/api'

const namespaced = true

const state = {
  notifications: []
}

const getters = {
  notifications: state => state.notifications
}

const mutations = {
  SET_NOTIFICATIONS: (state, payload) => {
    state.notifications = payload
  }
}

const actions = {
  async fetchNotification({ commit, rootGetters }, filterPayload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        ...filterPayload,
        search: filterConfig.search,
        page: filterConfig.currentPage || 1,
        limit: filterConfig.pageSize || 5
      }

      const { data } = await api.getApproachingTugs(filter)
      if (data.error) {
        commit('SET_NOTIFICATIONS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_NOTIFICATIONS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async fetchBargeLineUpIdByTugName(_, payload) {
    try {
      const { data } = await api.getBargeLineUpIdByTugName(payload)
      if (data?.error) {
        return { error: data?.error }
      }
      return data?.id
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
